import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-back\">\n<g id=\"icon-back_Group 427323851\">\n<path id=\"icon-back_Vector 25\" d=\"M15.6568 10.5506L9.99994 16.2075M9.99994 16.2075L15.6568 21.8643M9.99994 16.2075L22.4149 16.2075\" stroke=\"#DBDBDB\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol